var DataZoomModel = require("./DataZoomModel");

var _default = DataZoomModel.extend({
  type: 'dataZoom.select'
});

module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataZoom/SelectZoomModel.js
// module id = 785
// module chunks = 6